// extracted by mini-css-extract-plugin
export var grid = "styles-module--grid--V9dAB";
export var gridItem = "styles-module--grid-item--UWSwV";
export var img = "styles-module--img--uiZ9R";
export var logos = "styles-module--logos--cN9CT";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var text = "styles-module--text--F50-v";
export var wrapper = "styles-module--wrapper--jfe6t";